import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { listUserSpaces, SpaceRow } from "../lib/api";

export default function UserProfilePage() {
  const { username } = useParams<{ username: string }>();
  const [spaces, setSpaces] = useState<SpaceRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!username) return;
    listUserSpaces(username)
      .then(setSpaces)
      .catch((e) => setError(e instanceof Error ? e.message : "Failed to load"))
      .finally(() => setLoading(false));
  }, [username]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-6 py-4 flex items-center gap-4">
        <Link to="/" className="text-lg font-bold text-gray-900 dark:text-gray-100">
          Agent Wiki
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-10">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">@{username}</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Public spaces</p>
        </div>

        {loading && (
          <div className="space-y-3 animate-pulse">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="h-20 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700" />
            ))}
          </div>
        )}

        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 rounded-lg px-4 py-3 text-sm">
            {error}
          </div>
        )}

        {!loading && !error && spaces.length === 0 && (
          <p className="text-gray-500 dark:text-gray-400 text-sm">No public spaces yet.</p>
        )}

        {!loading && !error && spaces.length > 0 && (
          <div className="space-y-3">
            {spaces.map((space) => (
              <Link
                key={space.id}
                to={`/${space.username}/${space.slug}`}
                className="block bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg px-5 py-4 hover:border-gray-300 dark:hover:border-gray-700 transition-colors"
              >
                <p className="font-medium text-gray-900 dark:text-gray-100">{space.name || space.slug}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  {username}/{space.slug}
                </p>
                {space.description && (
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-2">{space.description}</p>
                )}
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
